import env from './.env';

// navigate to https://www.twilio.com/console/project/settings
// Twilio Credentials: developer@industrialsmart.com, password: Donotforget12#
export const environment = {
  production: true,
  test: false,
  protectedRoutes: true,
  version: env.package_version,
  supportedLanguages: [
  'en',
  'ne',
  'ru'
  ],
  config: {
    tenant: 'earthscout.onmicrosoft.com',
    clientId: '50fc9325-216d-4ad0-9e87-4d6697446d7b',
    redirectUri: 'https://admin.earthscout.com' + '/auth-callback',
    postLogoutRedirectUri: 'https://admin.earthscout.com' + '/login'
    // redirectUri: 'https://eadmin.azurewebsites.net' + '/auth-callback',
    // postLogoutRedirectUri: 'https://eadmin.azurewebsites.net' + '/login'
  },
  scoutLogApiUrl: 'https://efproductionscoutlogs.azurewebsites.net/api/',
  SCOUTLOG_API_KEY: 'OaNwQGY77wtGg/mAjXEc5XDe0PNkiRMbGNjRzoSPswkHXyuAmY1F/w==',
  apiUrl: 'https://escoutp.azurewebsites.net/',
  reportsApiUrl: 'https://escoutpreports.azurewebsites.net/',
  mobile: false,
  SENDGRID_API_KEY: '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'
};
